import { useEffect, useState } from 'react';

/** Below this width the 7 columns wrap to 2, so a bar can no longer run
    left-to-right across a week — the layout switches to stacked entries. */
const WC_NARROW = '(max-width: 760px)';
export function useNarrowCalendar(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(WC_NARROW).matches === true,
  );
  useEffect(() => {
    const mq = window.matchMedia?.(WC_NARROW);
    if (!mq) return;
    const sync = () => setNarrow(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);
  return narrow;
}
